<br />
<br />
<mat-sidenav-container>
  <mat-sidenav #sidenav position="end" mode="side">
    <section class="section-filtros">
      <header>
        <h1>Filtros</h1>

        <button mat-icon-button (click)="sidenav.close()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <app-reporte-filtros
        (filtrosAplicados)="filtros = $event; obtenerEquipos()"
        [disabled]="cargando"
      ></app-reporte-filtros>
    </section>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar>
      <h1>Reporte de Inventario de Equipos</h1>

      <div class="spacer"></div>

      <button
        style="margin-right: 0.5rem"
        mat-flat-button
        color="primary"
        (click)="obtenerEquipos()"
        [disabled]="cargando"
      >
        <mat-icon>search</mat-icon> Buscar
      </button>

      <button
        mat-icon-button
        matTooltip="Exportar a Excel"
        (click)="obtenerReporte()"
        [disabled]="descargando"
      >
        <mat-icon>file_download</mat-icon>
        <mat-spinner
          *ngIf="descargando"
          diameter="24"
          class="descargando"
        ></mat-spinner>
      </button>
      <button mat-icon-button (click)="sidenav.toggle()" matTooltip="Filtros">
        <mat-icon>tune</mat-icon>
      </button>
    </mat-toolbar>

    <div style="margin: 1rem; min-height: 720px">
      <mat-progress-bar
        *ngIf="cargando"
        mode="indeterminate"
      ></mat-progress-bar>

      <p *ngIf="error">{{ error }}</p>

      <mat-table [dataSource]="equipos?.content || []" class="mat-elevation-z8">
        <ng-container matColumnDef="tipoEquipo">
          <mat-header-cell *matHeaderCellDef> Tipo de Equipo </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.computertypes_id || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estatus">
          <mat-header-cell *matHeaderCellDef> Estatus </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ obtenerEstatus(row.states_id) || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="motivo">
          <mat-header-cell *matHeaderCellDef> Motivo </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.states_id || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="etiqueta">
          <mat-header-cell *matHeaderCellDef> Etiqueta </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.name || "-" }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="marca">
          <mat-header-cell *matHeaderCellDef> Marca </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.manufacturers_id || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="modelo">
          <mat-header-cell *matHeaderCellDef> Modelo </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.computermodels_id || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numSerie">
          <mat-header-cell *matHeaderCellDef> No. Serie </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.serial || "-" }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="colaboradorAsignado">
          <mat-header-cell *matHeaderCellDef>
            Colaborador Asignado
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.users_id || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaAsignacion">
          <mat-header-cell *matHeaderCellDef>
            Fecha Asignación
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ (row.fechaAsignacion | date: "dd/MM/yyyy") || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaAlta">
          <mat-header-cell *matHeaderCellDef> Fecha Alta </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ (row.fechaAlta | date: "dd/MM/yyyy") || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaBaja">
          <mat-header-cell *matHeaderCellDef> Fecha Baja </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ (row.fechaBaja | date: "dd/MM/yyyy") || "-" }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns"></mat-row>
      </mat-table>

      <div class="no-result" *ngIf="!cargando && !error && equipos?.empty">
        Sin resultados.
      </div>

      <mat-paginator
        class="mat-elevation-z8"
        [pageIndex]="paginacion.page"
        [length]="equipos?.totalElements || 0"
        (page)="onPageEvent($event)"
      ></mat-paginator>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
